import React, { useState } from 'react';
import { Bold, Italic, Link, Smile, Image, Calendar, Send, Twitter, Facebook, X, CheckCircle } from 'lucide-react';
export function PostComposer() {
  const [postContent, setPostContent] = useState('');
  const [selectedPlatforms, setSelectedPlatforms] = useState({
    twitter: true,
    facebook: false
  });
  const handlePlatformToggle = platform => {
    setSelectedPlatforms(prev => ({
      ...prev,
      [platform]: !prev[platform]
    }));
  };
  const characterLimit = 280; // Twitter character limit
  const remainingCharacters = characterLimit - postContent.length;
  const isOverLimit = remainingCharacters < 0;
  return <div className="space-y-4" data-id="element-162">
      {/* Text area with formatting options */}
      <div className="border rounded-lg" data-id="element-163">
        <div className="flex items-center gap-2 p-2 border-b" data-id="element-164">
          <button className="p-1.5 hover:bg-gray-100 rounded-md" data-id="element-165">
            <Bold size={18} className="text-gray-600" data-id="element-166" />
          </button>
          <button className="p-1.5 hover:bg-gray-100 rounded-md" data-id="element-167">
            <Italic size={18} className="text-gray-600" data-id="element-168" />
          </button>
          <button className="p-1.5 hover:bg-gray-100 rounded-md" data-id="element-169">
            <Link size={18} className="text-gray-600" data-id="element-170" />
          </button>
          <button className="p-1.5 hover:bg-gray-100 rounded-md" data-id="element-171">
            <Smile size={18} className="text-gray-600" data-id="element-172" />
          </button>
        </div>
        <textarea className="w-full p-4 min-h-[120px] resize-none focus:outline-none" placeholder="What's on your mind?" value={postContent} onChange={e => setPostContent(e.target.value)} data-id="element-173" />
        <div className="flex justify-between items-center p-2 border-t" data-id="element-174">
          <div className="flex items-center gap-2" data-id="element-175">
            <button className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-md" data-id="element-176">
              <Image size={16} className="text-gray-600" data-id="element-177" />
              <span className="text-sm text-gray-600" data-id="element-178">Add Media</span>
            </button>
          </div>
          <span className={`text-sm ${isOverLimit ? 'text-red-500' : 'text-gray-500'}`} data-id="element-179">
            {remainingCharacters} characters left
          </span>
        </div>
      </div>
      {/* Platform selection */}
      <div className="flex flex-wrap items-center gap-3" data-id="element-180">
        <span className="text-sm text-gray-600" data-id="element-181">Post to:</span>
        <button className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border ${selectedPlatforms.twitter ? 'bg-blue-50 border-blue-300 text-blue-600' : 'bg-white border-gray-300 text-gray-600'}`} onClick={() => handlePlatformToggle('twitter')} data-id="element-182">
          <Twitter size={16} data-id="element-183" />
          <span className="text-sm" data-id="element-184">Twitter</span>
          {selectedPlatforms.twitter && <CheckCircle size={14} className="ml-1" data-id="element-185" />}
        </button>
        <button className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border ${selectedPlatforms.facebook ? 'bg-blue-50 border-blue-300 text-blue-600' : 'bg-white border-gray-300 text-gray-600'}`} onClick={() => handlePlatformToggle('facebook')} data-id="element-186">
          <Facebook size={16} data-id="element-187" />
          <span className="text-sm" data-id="element-188">Facebook</span>
          {selectedPlatforms.facebook && <CheckCircle size={14} className="ml-1" data-id="element-189" />}
        </button>
      </div>
      {/* Preview panes */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-190">
        {selectedPlatforms.twitter && <div className="border rounded-lg p-4" data-id="element-191">
            <div className="flex items-center gap-2 mb-2" data-id="element-192">
              <Twitter size={16} className="text-[#1DA1F2]" data-id="element-193" />
              <span className="text-sm font-medium" data-id="element-194">Twitter Preview</span>
            </div>
            <div className="bg-gray-50 p-3 rounded-md min-h-[100px]" data-id="element-195">
              {postContent || <span className="text-gray-400" data-id="element-196">
                  Your tweet preview will appear here
                </span>}
            </div>
          </div>}
        {selectedPlatforms.facebook && <div className="border rounded-lg p-4" data-id="element-197">
            <div className="flex items-center gap-2 mb-2" data-id="element-198">
              <Facebook size={16} className="text-[#1877F2]" data-id="element-199" />
              <span className="text-sm font-medium" data-id="element-200">Facebook Preview</span>
            </div>
            <div className="bg-gray-50 p-3 rounded-md min-h-[100px]" data-id="element-201">
              {postContent || <span className="text-gray-400" data-id="element-202">
                  Your Facebook post preview will appear here
                </span>}
            </div>
          </div>}
      </div>
      {/* Action buttons */}
      <div className="flex justify-end gap-3" data-id="element-203">
        <button className="flex items-center gap-1.5 px-4 py-2 border rounded-md hover:bg-gray-50" data-id="element-204">
          <Calendar size={16} className="text-gray-600" data-id="element-205" />
          <span data-id="element-206">Schedule</span>
        </button>
        <button className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-207">
          <Send size={16} data-id="element-208" />
          <span data-id="element-209">Post Now</span>
        </button>
      </div>
    </div>;
}